import { FC, memo } from "react";
import { StreamStateView } from "./StreamStateView";

type StreamTimeoutViewProps = {
  onRetry: () => void;
};

export const StreamTimeoutView: FC<StreamTimeoutViewProps> = memo(({ onRetry }) => (
  <StreamStateView
    title="Stream took too long to start"
    message="The camera may be unreachable. Check your connection and try again."
    onRetry={onRetry}
  />
));

StreamTimeoutView.displayName = "StreamTimeoutView";
